import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import OrdersListTable from './ordersList/OrdersListTable';
import OrderDetails from './OrderDetails';
import CookView from '../cook-view';
import { default as ordersStore } from 'store/ordersStore';
import { default as restaurantStore } from 'store/restaurantDetailsStore';
import { useStyles } from './OrderDetails/styles';
import { Positions } from 'constants/enums';
import menusStore from 'store/menusStore';
import { useAppSelector } from 'index';
import { useLocation } from 'react-router-dom';

export const OrdersPage = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const location = useLocation<{ skipFirstLoad?: boolean }>();

    const user = useAppSelector((state) => state.user);
    const menus = useAppSelector((state) => state.menus);
    const currentRestaurant = user.restaurants?.filter((x) => x.id === user.currentRestaurantId)[0];
    //const isNavBarOpen = useSelector((state: ApplicationState) => state.ui.navBarOpen);
    const skipFirstLoad = location.state?.skipFirstLoad;

    /* const containerWidth = isNavBarOpen ? '100%' : 'calc( 100% + 187px)'; */
    const containerWidth = '100%';

    useEffect(() => {
        if (currentRestaurant?.currentPosition === Positions.COOK) {
            dispatch(
                ordersStore.actionCreators.getPositionOrders(
                    currentRestaurant.currentPosition || Positions.WAITER
                )
            );
        } else if (
            currentRestaurant?.currentPosition === Positions.WAITER ||
            currentRestaurant?.currentPosition === Positions.MANAGER
        ) {
            dispatch(restaurantStore.actionCreators.getRestaurantResponsibleUsers());
        }
        menus.dishList.length === 0 && dispatch(menusStore.actionCreators.getDishList());
        const layout = document.querySelector('.MuiContainer-root.MuiContainer-maxWidthLg');
        const defaultStyle = (layout as HTMLElement).style.backgroundColor;
        if (!!layout) {
            (layout as HTMLElement).style.backgroundColor = 'transparent';
        }

        return () => {
            (layout as HTMLElement).style.backgroundColor = defaultStyle;
        };
    }, [currentRestaurant]); // eslint-disable-line

    if (!user.areRestaurantsSettled) {
        return null;
    }

    if (currentRestaurant?.currentPosition === Positions.COOK) {
        return <CookView />;
    }

    return (
        <div
            className={classes.ordersPage}
            style={{
                width: containerWidth,
            }}
        >
            <OrdersListTable
                workAreas={[]}
                handleCategory={() => {}}
                skipFirstLoad={skipFirstLoad}
            />
            <OrderDetails />
        </div>
    );
};
